import React from 'react';
import { Droplet, AlertTriangle, ShieldCheck } from 'lucide-react';
import { WATER_DATA, getCountryData } from '@/data/essentials';

export default function WaterCard({ countryCode, countryName }) {
  const d = getCountryData(WATER_DATA, countryCode);
  const safe = !!d.tap_safe;
  return (
    <div className="puvio-card p-5" data-testid="water-card">
      <div className="flex items-start justify-between">
        <div>
          <p className="font-bold text-[11px] uppercase tracking-[0.22em] text-[var(--puvio-mint-deep)]">Water & Health</p>
          <p className="text-xs text-[var(--puvio-text-2)] mt-0.5 font-medium">{countryName || 'Local advisory'}</p>
        </div>
        <div className="w-12 h-12 rounded-2xl flex items-center justify-center" style={{ background: safe ? '#D2F4E5' : '#FCE4E4' }}>
          <Droplet className={`w-6 h-6 ${safe ? 'text-[var(--puvio-mint-deep)]' : 'text-[var(--puvio-coral-deep)]'}`} />
        </div>
      </div>
      <div className="mt-4 flex items-center gap-2">
        {safe ? (
          <span className="inline-flex items-center gap-1.5 puvio-pill text-xs font-bold" style={{ background: '#D2F4E5', color: '#1F6F49' }} data-testid="water-safety-pill">
            <ShieldCheck className="w-3.5 h-3.5" /> Tap water safe
          </span>
        ) : (
          <span className="inline-flex items-center gap-1.5 puvio-pill text-xs font-bold" style={{ background: '#FCE4E4', color: '#A22323' }} data-testid="water-safety-pill">
            <AlertTriangle className="w-3.5 h-3.5" /> Bottled only
          </span>
        )}
      </div>
      <p className="text-[13px] text-[#0F1A13] mt-3 leading-relaxed font-medium">{d.guidance}</p>
      {Array.isArray(d.risks) && d.risks.length > 0 && (
        <ul className="mt-3 space-y-1.5">
          {d.risks.map((r, i) => (
            <li key={i} className="text-[12px] text-[var(--puvio-text-2)] flex gap-2">
              <span aria-hidden="true" className="text-[var(--puvio-coral-deep)] font-bold">·</span>
              <span>{r}</span>
            </li>
          ))}
        </ul>
      )}
      {Array.isArray(d.advisories) && d.advisories.length > 0 && (
        <div className="mt-3 rounded-2xl bg-amber-400/15 border border-[#F6C84F] p-3">
          <p className="text-[10px] uppercase tracking-[0.2em] font-extrabold text-[#B85F31]">Health advisories</p>
          <ul className="mt-1.5 space-y-1">
            {d.advisories.map((a, i) => (
              <li key={i} className="text-[12px] text-[#0F1A13] font-medium">• {a}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
